import { Gizmo, RootGizmo } from '../gizmos';
import { IGizmo, IGizmoFeatures, IError } from '../types';

/**
 * Class that will be extended by all binders, basically it exposes gizmo's stuff
 * that will be accessed by the platform layer. We're doing this in order to prevent
 * the platform layer to interact with the binder and with the gizmo instance. With
 * this it can interact only with the binder instance.
 */
class CommonBinder {
  protected _gizmo: Gizmo;

  constructor(gizmo: Gizmo) {
    this._gizmo = gizmo;
  }

  /**
   * Wrapper for gizmo's validate function
   *
   * @returns {Promise<IError[]>} validation errors
   */
  public validate = (): Promise<IError[]> => {
    return this._gizmo.validate();
  };

  public getConfig = (): IGizmo => {
    return this._gizmo.getConfig();
  };

  public getFeatures = (): IGizmoFeatures => {
    return this._gizmo.getFeatures();
  };

  public getGizmos = (): (RootGizmo | Gizmo)[] | undefined => {
    return this._gizmo.getGizmos();
  };
}

export default CommonBinder;
